import styled, { css } from 'styled-components';

export const StyledDivider = styled.div`
  background-color: ${({ theme }) => theme.palette.primary.gray};
  border: unset;
  width: 1px;

  ${({ theme }) => css`
    ${theme.media.mobile} {
      width: 100%;
      height: 1px;
    }
  `}
`;
